export const MUHURAT_HEADLINES = { en: "Shubh Muhurat Today", hi: "शुभ मुहूर्त" } as const;
